<app-header></app-header>
<!-- Main Content -->
<main class="main-container">
  <section class="main-content">
    <router-outlet></router-outlet>
  </section>
  @if (toggleSidebar | async) {
  <aside class="sidebar-content" @fadeSlideInOut>
    <app-sidebar></app-sidebar>
  </aside>
  }
</main>
<app-new-project-dialog-entry></app-new-project-dialog-entry>

<app-footer></app-footer>
